import * as S from "./ExerciseWeeklyList.style";
import { Video } from "@/common/types/video";
import { ExerciseWeeklyItem } from "@/components/atoms/ExerciseWeeklyItem";
import { Loading } from "@/components/atoms/Loading";

interface ExerciseWeeklyListProps {
  videos: Video[];
  onClick: (videoId: string) => void;
  isLoading: boolean;
}

export const ExerciseWeeklyList = ({
  videos,
  onClick,
  isLoading,
}: ExerciseWeeklyListProps) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <S.ExerciseWeeklyList>
      {videos.map((video: Video, idx: number) => {
        return <ExerciseWeeklyItem video={video} key={idx} onClick={onClick} />;
      })}
    </S.ExerciseWeeklyList>
  );
};
